// extracted by mini-css-extract-plugin
export default {"fileNameBtn":"fileNameBtn---E1dQB","disabledFileName":"disabledFileName---RUsYM","downloadFile":"downloadFile---rfQBS"};